//////// GHG EF 3.6
const threeSixSchema = {
  title: "3.6 Business Travel",
  cat: "3_5",
  catName: "cat3",
  progressiveOrderSwitch: {
    by: { level: 4, key: "sourceEFName" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    //////// Data Source
    {
      key: "emissionFactorTypeId",
      level: 3,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "emissionFactorTypeId",
      },
      showIf: {
        all: [
          { level: 3, key: "emissionFactorTypeId", ne: "2" },
          { level: 3, key: "emissionFactorTypeId", notEmpty: true },
        ],
      },
      combineKey: 1,
    },
    ////////////////Distance Based
    //////// Transport Model (Distance Based)
    {
      key: "transportModel",
      level: 5,
      type: "select",
      label: "Transport Model",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: {
        level: 4,
        key: "sourceEFName",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: 2,
        formData: "EAFormData",
      },
      combineKey: 2,
    },
    ////////Vehicle Category
    {
      key: "fuelTypeOrVehicleCategory",
      level: 6,
      type: "select",
      label: "Vehicle Category",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "transportModel",
      },
      showIf: {
        level: 5,
        key: "transportModel",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: "2",
        formData: "EAFormData",
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (Distance Based)
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Vehicle Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelTypeOrVehicleCategory",
      },
      showIf: {
        level: 6,
        key: "fuelTypeOrVehicleCategory",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: "2",
        formData: "EAFormData",
      },
      combineKey: 4,
    },
    ////////Vehicle Category (Fuel Based)
    {
      key: "fuelTypeOrVehicleCategory",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: {
        level: 4,
        key: "sourceEFName",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: "3",
        formData: "EAFormData",
      },
      combineKey: 2,
    },
    ////////Emission Factor Name (Fuel Based)
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelTypeOrVehicleCategory",
      },
      showIf: {
        level: 6,
        key: "fuelTypeOrVehicleCategory",
        notEmpty: true,
      },
      specialDataShouldIf: {
        level: 2,
        key: "calculationId",
        eq: "3",
        formData: "EAFormData",
      },
      combineKey: 3,
    },
    //////// Transport Model (Passenger Distance Based)
    {
      key: "transportModel",
      level: 5,
      type: "select",
      label: "Transport Model",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: {
        level: 4,
        key: "sourceEFName",
        notEmpty: true,
      },
      specialDataShouldIf: {
        any: [
          { level: 2, key: "calculationId", eq: 4 },
          { level: 2, key: "calculationId", eq: 5 },
          { level: 2, key: "calculationId", eq: 6 },
        ],
        formData: "EAFormData",
      },
      combineKey: 2,
    },
    ////////Vehicle Category (Passenger Distance Based)
    {
      key: "fuelTypeOrVehicleCategory",
      level: 6,
      type: "select",
      label: "Vehicle Category",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "transportModel",
      },
      showIf: {
        level: 5,
        key: "transportModel",
        notEmpty: true,
      },
      specialDataShouldIf: {
        any: [
          { level: 2, key: "calculationId", eq: 4 },
          { level: 2, key: "calculationId", eq: 5 },
          { level: 2, key: "calculationId", eq: 6 },
        ],
        formData: "EAFormData",
      },
      combineKey: 3,
    },
    ////////Vehicle Type (Passenger Distance Based)
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Vehicle Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelTypeOrVehicleCategory",
      },
      showIf: {
        level: 6,
        key: "fuelTypeOrVehicleCategory",
        notEmpty: true,
      },
      specialDataShouldIf: {
        any: [
          { level: 2, key: "calculationId", eq: 4 },
          { level: 2, key: "calculationId", eq: 5 },
          { level: 2, key: "calculationId", eq: 6 },
        ],
        formData: "EAFormData",
      },
      combineKey: 4,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 7,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat3CustomEFDropdownList",
      showIf: {
        level: 3,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum:0,
    },
  ],
};

export default threeSixSchema;
